export function replaceNumText(str: string, ...classNameList: string[]) {
	if (!str || !classNameList.length) {
		return str;
	}
	let index = 0;
	const numReg = /(\d+)/g;
	return str.replace(numReg, (_match, p) => {
		const className = classNameList[index];
		index++;
		return `<span class='${className}'>${p}</span>`
	})
}